import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProgramCard({ programDetails, handleEstimate }: any) {
  const defaultImage = require('../../assets/img/default programs.png');
  const navigate = useNavigate();

  const imageUrl =
    programDetails?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || defaultImage;
 

  const handleDetails = () => {
    navigate(`/programs/${programDetails?.Id}`, { state: { programDetails } });
  };
  return (
    <div className="w-72 h-[420px] mx-2 bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-[1.02] transition-transform duration-300 border border-gray-200 mb-6 flex flex-col justify-between">
      <div className="relative h-48 "onClick={handleDetails}>
        <img
          src={imageUrl}
          alt="programDetails"
          className="w-full h-full object-cover"
        />
      <div className="absolute top-3 right-3 bg-white bg-opacity-90 text-blue-600 text-sm font-bold px-3 py-1 rounded-full shadow">
  {/* {programDetails?.ONEMemberships?.[0]?.EntityInfo?.IsFreeOfCost === true
    ? 'Free'
    : programDetails?.ONEMemberships?.[0]?.EntityInfo?.Price
      ? programDetails.ONEMemberships[0].EntityInfo.Price
      : 'Contact us'} */}
</div>


      </div>

      <div className="p-5 bg-gradient-to-b from-white via-gray-50 to-white text-center flex-1 overflow-hidden flex flex-col justify-between">
        <div className="overflow-auto max-h-[260px] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent text-left">
          <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">
            {programDetails?.Name}
          </h3>
         
        </div>

        
      </div>

       
    </div>

    
  );
}
